<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">My Shopping Orders</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">My Orders</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="popular-menu-area pb-80 pt-custom" style="padding-top: 0">
            <div class="container">
                <div class="row align-items-center pt-65 pb-20">
                    <div class="col-md-4">
                        <div class="product-grid-tab d-flex">
                            <span>{{searchy? searchMyOrders.length :myOrders.length}} orders </span>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="product-grid-select float-left float-md-right">
                            <ul>
                                <li>
                                    <form class="form-inline" @submit.prevent="search">
                                        <div class="form-group mx-sm-3 mb-2">
                                            <input v-model="form.search" type="text" class="form-control"
                                                   placeholder="Enter Order Number">
                                        </div>
                                        <button type="submit" :disabled="!form.search ? true : false" class="btn btn-primary mb-2"><i class="fas fa-search"></i>
                                        </button>
                                    </form>
                                </li>
                                <small style="color: red" v-if="error && errors.search">{{ errors.search[0] }}</small>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6" v-for="order in pageOfItems" :key="order.id">
                        <div class="popular-menu-item mt-30 d-flex align-items-center bg-white">
                            <div class="popular-menu-thumb mr-30">
                                <router-link :to="{name: 'my-order-details', params: {orderNo: order.orderNo}}">
                                    <img src="/img/transmall-order.jpg" alt="drinks" style="width: 100px">
                                </router-link>
                            </div>
                            <div class="popular-menu-content">
                                <router-link :to="{name: 'my-order-details', params: {orderNo: order.orderNo}}">
                                    <h5 class="title">#{{order.orderNo}}</h5>
                                </router-link>
                                <span>Ksh.{{order.sub_total}}</span>
                                <p>Placed on {{moment(order.created_at).format('MMMM Do YYYY, h:mm a')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row text-center" v-if="searchy && searchMyOrders.length < 1">
                    <small class="text-danger">There is no order with an 0rder Number {{form.search}}</small>
                </div>
                <div class="mt-100">
                    <p class="text-center" v-if="!searchy">
                        <jw-pagination :items="myOrders" @changePage="onChangePage" :labels="customLabels"
                                       :pageSize="8"></jw-pagination>
                    </p>
                    <p class="text-center" v-if="searchy">
                        <jw-pagination :items="searchMyOrders" @changePage="onChangePage" :labels="customLabels"
                                       :pageSize="8"></jw-pagination>
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    let moment = require('moment');
    const customLabels = {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
    };
    export default {
        name: "MyOrders",
        data() {
            return {
                error: false,
                errors: {},
                searchy: false,
                moment,
                customLabels,
                pageOfItems: [],
                form: {
                    search: ''
                }
            }
        },
        computed: {
            searchMyOrders() {
                let filtered = this.myOrders;
                if (this.form.search) {
                    return filtered = this.myOrders.filter(m => m.orderNo == this.form.search)
                }else {
                    return filtered;
                }
            },
            myOrders() {
                return this.$store.state.orders;
            }
        },
        methods: {
            search() {
                this.searchy = true;
            },
            onChangePage(pageOfItems) {
                this.pageOfItems = pageOfItems;
            },
            getMyOrders() {
                this.$store.dispatch('retrieve_orders_customer');
            }
        },
        created() {
            this.getMyOrders();
        }
    }
</script>

<style scoped>

</style>